export function isDomContentLoaded () {
  const timing = performance.getEntriesByType("navigation");
  if (timing.length) {
    // console.log('performance.getEntriesByType');
    return !!performance.getEntriesByType("navigation")[0].domContentLoadedEventEnd;
  } else {
    // console.log('performance.timing');
    return !!performance.timing.domContentLoadedEventEnd;
  }
}
